import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeInventoryListScreen from './screens/ChargeInventoryListScreen';

ChargeInventory.propTypes = {};

function ChargeInventory(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="" element={<ChargeInventoryListScreen />} />
                    {/* <Route path=":chargePricingId" element={<ChargePricingDetailScreen />} /> */}
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ChargeInventory;
